import { Archive, Check } from "lucide-react"
import { inboxIssueSeverityClassName, inboxIssueStatuses } from "../lib/inboxIssueStatus"

export function InboxIssueStatusMark({ issue }) {
  if (issue?.status === inboxIssueStatuses.done) {
    return (
      <span className="issue-status-mark is-done" aria-hidden="true">
        <Check strokeWidth={2.4} />
      </span>
    )
  }

  if (issue?.status === inboxIssueStatuses.archived) {
    return (
      <span className="issue-status-mark is-archived" aria-hidden="true">
        <Archive strokeWidth={2.2} />
      </span>
    )
  }

  return <span className={inboxIssueSeverityClassName(issue)} aria-hidden="true"></span>
}
